export default __webpack_public_path__ + "static/media/aktuell_5.ccaae683.jpg";